import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";
import MinPlanPrice from "../../Components/MinPlanPrice";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function Office365() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Boost Productivity with Office 365: Tips for Businesses";
        sal();
      }, []);
      const handlePlanClick = () => {
    ScrollToPlans(".price-plan-section");
    };
  return (
    <>
    <Helmet>
        <title>Boost Productivity with Office 365: Tips for Businesses</title>
        <meta name="description" content="Office 365 brings productivity and collaboration with cloud apps, email, and seamless integration for your team, boosting efficiency and teamwork everywhere.." />
        <meta name="keywords" content="Microsoft Office 365, Office365, Microsoft 365 Business, Windows 365, Microsoft 365 Business Standard, Office 365 Business, Windows Office, Office 365" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/office-365`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/office-365`} />
        <meta property="og:title" content="Microsoft Office 365 Email Hosting - Affordable Hosting Prices" />
        <meta property="og:description" content="Enhance your productivity with our Office 365 solutions. It provides a robust platform for productivity that offers applications like Excel, PowerPoint, etc." />
    </Helmet>
    <section className="banner-bg bg-dark ssl-banner">
        <div className="container">
            <div className="row align-items-center g-4">
                <div className="col-xl-6 col-lg-6">
                    <div className="pb-40">
                        <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Your Workday, Upgraded.</span>
                        <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Office 365: Your Team. Your Tools.</h1>
                        <p className="text-white mb-8 max-text-60 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">What if your whole office could follow you-anywhere you go, even on vacations? With the help of Office 365, all your work tools, files, and team collaboration are always within your reach. Ranging from emails to documents to real-time chats, everything you wish for travels with you.
                        </p>
                        <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                            <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded sal-animate btn-height" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <span className="btn-arrow__text">
                                    View All Plans
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </button>
                            <MinPlanPrice category="microsoft-365" />
                        </div>
                        <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                    </div>
                </div>
                <div className="col-lg-6 col-xxl-6 ipad-mt"><div className="cloud-hero__img sal-animate" data-sal="fade" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine"><img alt="image" className="img-fluid full-width-img" src="/images/office-365-your-dedicated.webp"/></div></div>
            </div>
        </div>
    </section>

      <section className="simple-box-section position-relative z-1 overflow-hidden">
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-10">
                          <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                              <div className="card-body pt-60 pb-60">
                                  <div className="row justify-content-center">
                                    <div className="col-md-11 col-lg-10 col-xl-10">
                                        <div className="text-center">
                                          <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Work Anywhere. Stay In Sync.</span>
                                            <h4 className="mb-4">
                                                Microsoft Office 365 Email Hosting Developed for Mobile-Based Teams
                                            </h4>
                                            <p className="mb-6">
                                              Sick of juggling emails, files, and meetings across different devices? Umm… Relax, not with us. Migrating to Microsoft Office 365 with Infinitive Host changed the whole mailing game. Now, it’s all about everything in a single place-fast, smooth, and always on, 24/7.
                                            </p>
                                            <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    +91-7737300013
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                            <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    Talk to an Expert
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
      </section>

      <div className="pt-100 pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center justify-content-xl-between">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>All Your Tools. One Workspace.
                        </small>
                        <h2 className="mb-4">
                            Think Every MS Office 365 Hosting is the Same? Think Again.
                        </h2>
                    </div>
                    <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="card">
                            <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/deadlines-handled.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Deadlines? Handled
                            </h6>
                            <p className="mb-0">
                                Say bye-bye to all chaos. With the help of Infinitive Host’s Microsoft Office 365 plans, especially in India, you get unbeatable teamwork, proper communication, and pricing.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/inbox-detox-starts.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                New Inbox, Who Dis?
                            </h6>
                            <p className="mb-0">
                                Stressed about your emails disappearing or the move being chaotic? Don’t worry about it. Infinitive Host makes migration to Office 365 clean and hassle-free.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/in-sync-no-matter.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                In Sync, No Matter What
                            </h6>
                            <p className="mb-0">
                                Tired of miscommunication and infinite threads? With the help of our Microsoft Office 365, sharing and syncing with your whole team is smooth.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/zero-chill-on.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                24/7? We Mean It
                            </h6>
                            <p className="mb-0">
                                Always stuck on a “what do I click now?” moment? Infinitive Host’s real-human (no bots) team is online 24/7 just to troubleshoot it as fast as possible-no computer, no delays.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/beyond-hackers.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Hackers? No Worries
                            </h6>
                            <p className="mb-0">
                                What if everything disappears the next day? With the help of Infinitive Host, your data is secure, backed up, and shielded. No more broken links, no more unexpected crashes.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/no-more-I-lost-it.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                No More “I Lost It!”
                            </h6>
                            <p className="mb-0">
                                What if you lost that one most important email forever? With Infinitive Host, all your details and files are backed up like clockwork. No worry, no “oops,” just relaxation.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <section className="price-plan-section pt-100 pb-100">
          <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
          <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-8">
                          <div className="text-center">
                              <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                              <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Run Your Day with Office 365.</h2>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <PlanList category={'microsoft-365'}/>
      </section>

      <section className="bg-light-13 pt-100 pb-100">
        <div className="container">
            <div className="row">
                <div className="col-xl-9">
                    <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Documents Done Right.</small>
                    <h2 className="mb-0">Inside the Inbox: What Makes Office 365 Hosting Unique</h2>
                </div>
            </div>
            <div className="mt-12">
                <div className="row g-4">
                    <div className="col-lg-4">
                        <div className="bg-primary p-5 rounded-3 mb-8">
                            <div className="bg-white p-4 rounded-3 mb-8">
                                <div className="text-center">
                                    <img src="/images/support.png" alt="Image" className="img-fluid mb-3"/>
                                    <h6 className="mb-2">Infinitive Support</h6>
                                    <p className="mb-4">Technical Support specialists</p>
                                    <div className="style_15 d-inline-flex align-items-center justify-content-center gap-2">
                                        <Link to="https://wa.me/+917742553946?text=I recently check out your official website and was impressed by your web hosting solutions. I’m ready to buy a web hosting plan that matches my requirements. Could you please help me through the process?" target="_blank" rel="noopener noreferrer" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-whatsapp"></i></span>
                                        </Link>
                                        <Link to="https://www.instagram.com/infinitive_host" target="_blank" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-instagram"></i></span>
                                        </Link>
                                        <Link to="https://www.linkedin.com/company/infinitivehost/" target="_blank" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-linkedin-in"></i></span>
                                        </Link>
                                        <Link to="https://www.facebook.com/InfinitiveHost-435551663445191" target="_blank" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-facebook-f"></i></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <h6 className="text-white mb-5">Industry Leading Live Support - 24/7</h6>
                            <p className="text-white mb-8">We always put our customers first, from product planning to every single chat and ticket. With 20+ years of hosting experience, we’ll make sure you have a fantastic experience.</p>
                            <Link to="#" className="btn btn-light border-0 btn-arrow btn-arrow-md fs-14 fw-medium rounded open-live-chat btn-height">
                                <span className="btn-arrow__text">
                                    LiveChat
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                        <img src="/images/live_chat_img.webp" alt="Image" className="img-fluid d-lg-block d-none"/>
                    </div>
                    <div className="col-lg-8">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/work-win-together.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Work & Win Together</h6>
                                    <p className="mb-0">Sick of juggling apps just to get an easy task done? MS Office 365 always keeps your team synced-share, co-edit, and grow from one clean space.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/trust-built-in.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">
                                    Trust? Built-In </h6>
                                    <p className="mb-0">What if your email just... failed unexpectedly? With the help of 99.9% uptime and robust security, MS Office 365 has your back-no more crashes.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/advanced-tools-more-wins.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Advanced Tools, More Wins</h6>
                                    <p className="mb-0">Office 365’s Power BI and Excel make a lot of sense of your numbers. Built-in smarts mean fewer errors, improved decisions, and way less hassle.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/comfort-in-every-click.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">
                                    Comfort in Every Click</h6>
                                    <p className="mb-0"> Sick of waiting for your “office device”? Office 365 works wherever you want to-across your phone, tablet, etc. Same tools, same vibe, no friction.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                               <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/login-done-perfectly.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">
                                    Login Done Perfectly</h6>
                                    <p className="mb-0">Annoyed by too many login attempts? One sign-in unlocks everything that you wish for. With Office 365, it’s smooth, protected, and hassle-free.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/switch-made-simple.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Switch Made Simple</h6>
                                    <p className="mb-0">Sick of moving your data again & again? Don’t worry-we manage the migration with zero lost files or headaches. You just select where you left off.</p>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <div className="pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6 ipad-mt sal-animate order-lg-0 order-1" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/time-managed-tasks-managed.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                    <div className="col-lg-6 order-lg-1 order-0">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Everything Managed Successfully
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Time? Managed. Tasks? Managed. Inbox? Oops-Moment Free.
                            </h3>
                            <ul>
                                <li>Our MS Office 365 email hosting lets you remain in control-anytime.</li>
                                <li>Give priority to your day with to-do lists, important emails, & alerts.</li>
                                <li>Ranging from setting virtual meetings to cleaning up your mailbox.</li>
                                <li>No more chaos, no more mess-just a way to manage your time & team.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-60 ipad-mt">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                All Your Tools. One Workspace.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Your Office & Device, In Your Pocket
                            </h3>
                            <ul>
                                <li>No IT team required-our Outlook email hosting is completely smooth.</li>
                                <li>Save your money with Infinitive Host’s budget-friendly email tools.</li>
                                <li>Plan, prioritize, & handle tasks with ease with all-in-one email suite.</li>
                                <li>Stay excellently in sync-ranging from emails to calendars.</li>
                            </ul>
                            <Link to="#" onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Get Started Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate ipad-mt" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/your-office-&-device.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6 sal-animate ipad-mt order-lg-0 order-1" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/turn-every-conversation.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                    <div className="col-lg-6 order-lg-1 order-0">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Productivity, Powered By 365.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Turn Every Conversation Into Fruitful Collaboration
                            </h3>
                            <ul>
                                <li>Share data with only genuine people via MS Office 365.</li>
                                <li>Sync calendars, contacts, and everyday tasks, with remote team.</li>
                                <li>Share contacts or collaborate with user-friendly cloud email tools.</li>
                                <li>Find what you want with advanced search that saves your time.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-10">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                From Inbox To Impact.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Where “Oops, It’s Down” Doesn’t Exist
                            </h3>
                            <ul>
                                <li>Get a 99.9% uptime and productive server upgrades anytime.</li>
                                <li>Instant setup & maintenance with seamless DNS management.</li>
                                <li>Stay always relaxed with secure, reliable Office 365 email hosting.</li>
                                <li>Hit a glitch? Our MS expert team is there for you every time, 24/7.</li>
                            </ul>
                            <Link to="#" onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Get Started Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-6 sal-animate ipad-mt" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/where-oops-it’s-down.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section className="pt-60 pb-100">
        <div className="container">
            <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                <div className="row justify-content-center">
                    <div className="col-xxl-7 col-xl-9">
                        <div className="d-flex justify-content-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2">
                                <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                <small className="text-primary fw-bold">Less Switching. More Doing.</small>
                            </div>
                        </div>
                        <div className="text-center mt-5">
                            <h2 className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Blink & See You’re Live.</h2>
                            <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Office 365: Your Team’s New Fav Place to Work-Hosted by One & Only Infinitive Host </p>
                        </div>
                        <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <Link to="#" onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Start Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                            <Link to="/frequently-asked-questions" className="btn btn-dark btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Learn More
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
    </>
  );
}
